module.exports = __webpack_public_path__ + "img/FMlogo.d3c5b5f0.png";